import axios from 'axios';

const addNewPurchaseOrderApi = async (token, values, edit = false) => {
  try {
    let url;
    if (!edit) url = '/BuyOrder/create';
    else url = '/BuyOrder/update';

    const res = await axios.post(url, values, {
      headers: {
        lang: 'ar',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addNewPurchaseOrderApi;
